import env from '@framework/env/env';
import domain from '@framework/config/domain';

const config = {
  name: 'Allocate',
  code: 'allocate' as const,
  abbr: 'ALC',
  supportEmail: env('CREDENTIALS__ALLOCATE__SUPPORT__EMAIL'),
  hostname: `${ domain.allocateDomain }`,
  isConsentForEDeliveryRequired: false,
  ga: {
    trackingId: env('GA__TRACKING_ID_ALLOCATE'),
  },
  gtm: {
    trackingId: env('FRONTEND___GOOGLE_TAG_MANAGER__TENANT_ALLOCATE__GTM_ID'),
  },
  api: {
    external: `${ domain.protocol }//${ domain.allocateDomain }`,
    internal: env('ALLOCATE_WS__HOSTNAME_INTERNAL'),
  },
};

export default config;
